module.exports = __webpack_public_path__ + "static/media/project-car.89ef263b.jpg";